import Image from "./image";
import React from "react";

export const FeaturedOverview = ({ overview, index }) => {
  const image = (
    <div className="flex flex-col items-center justify-center">
      {overview.image?.url && (
        <Image alt={overview.title} image={overview.image} />
      )}
    </div>
  );
  return (
    <div key={overview.id} className={`grid lg:grid-cols-2 gap-8 mb-16`}>
      {index % 2 === 0 ? image : null}
      <div>
        <p className={`font-display font-bold text-[24px] my-4 leading-none`}>
          {overview.title}
        </p>
        <p className={`font-display text-[18px]`}>{overview.content}</p>
      </div>
      {index % 2 !== 0 ? image : null}
    </div>
  );
};
